module.exports = "https://cdn.hellotech.com/client-assets/yale_locks_desktop_54038bc3f68e761e777fbf720808a7ab.png";